module.exports = new __parcel__URL__("What areas are actively trying to improve and just maintain in the next 12 months_ v1.5427d6df.svg").toString();